import { Dispatch } from "redux";
import { ReduxStateObj } from "@al/base-lib/dist/ReduxHelper/types";

import Analytics from "~/common/tracker/analytics";

import { ProductDetailType, AddressItemType, SkuInfoType } from "../types";

import { getSkuPrice, getFreight, getInstallmentPlants } from "./requestFunc";
import * as actions from "./actions";
import { StateType } from "./reducer";

// 用于获取用户登录信息的，异步 action 使用方法参考 https://www.redux.org.cn/docs/advanced/AsyncActions.html

export function getFreightAction({
  currentSku,
  detail,
  count,
  defaultAddress,
}: {
  currentSku: SkuInfoType;
  detail: ProductDetailType;
  // 购买数量
  count?: number;
  defaultAddress: AddressItemType;
}) {
  return (dispatch: Dispatch<ReduxStateObj>): Promise<void> => {
    return getFreight({ dispatch, currentSku, detail, count, defaultAddress }).then(({ success, data }: any) => {
      success && dispatch(actions.setFreightInfo(data));
    });
  };
}

export function getInstallmentPlantsAction({
  currentSku,
  detail,
  count,
  sellingPrice,
}: {
  currentSku: SkuInfoType;
  detail: ProductDetailType;
  // 购买数量
  count?: number;
  sellingPrice?: number;
}) {
  return (dispatch: Dispatch<ReduxStateObj>): Promise<void> => {
    return getInstallmentPlants({ dispatch, currentSku, detail, count, sellingPrice }).then(
      ({ success, data }: any) => {
        success && dispatch(actions.setInstallmentPlans(data.items));
      }
    );
  };
}

export function updateSkuPrice({
  spuId,
  skuId,
  isFirst,
  count,
}: {
  spuId?: string;
  skuId?: string;
  // 是否第一次请求，如果是第一次请求，则不需要实时库存和自动选择sku
  isFirst?: boolean;
  // 购买数量
  count?: number;
}) {
  return (dispatch: Dispatch<ReduxStateObj>, getState: () => ReduxStateObj): Promise<void> => {
    const state = (getState() as any).sku_detail.static as StateType;
    const detail = state.detail;
    const defaultAddress = state.defaultAddress;
    if (!detail || !defaultAddress) return Promise.resolve();
    const curSkuId = skuId || state.currentSku?.skuId;
    const curSpuId = spuId || detail.spuId;
    const selectSku = detail.skuInfos?.find((item) => item.skuId === curSkuId);
    dispatch(actions.setPageLoading(true));
    return getSkuPrice({ dispatch, spuId: curSpuId, detail, count, selectSku, defaultAddress, isFirst }).then(
      async ({ success, data }: any) => {
        let currentSku;
        if (success) {
          currentSku = detail.skuInfos.find((item) => item.skuId === data.skuId);
          dispatch(actions.setSkuPrice(data));
          // 首次初始化存储 库存和分期信息
          if (isFirst) {
            dispatch(actions.setSaleStockInfos(data.saleStockInfos));
          }
          // 当前选中 sku 的库存
          if (currentSku) {
            dispatch(actions.setCurrentSku(currentSku));
            dispatch(getInstallmentPlantsAction({ currentSku, sellingPrice: data?.sellingPrice, detail, count }));
            await dispatch(getFreightAction({ currentSku, detail, defaultAddress, count }));
          }
        } else {
          // 请求失败默认选中 skuInfo 第一个 sku
          currentSku = detail.skuInfos?.[0];
          if (currentSku) {
            dispatch(actions.setCurrentSku(currentSku));
            dispatch(getFreightAction({ currentSku, detail, defaultAddress, count }));
            dispatch(getInstallmentPlantsAction({ currentSku, sellingPrice: data?.sellingPrice, detail, count }));
          }
        }
        dispatch(actions.setPageLoading(false));

        // 只允许触发一次.
        if (!state.isInitReport) {
          // 上报商品埋点信息
          Analytics.trackEvent("productDetail", {
            countryId: detail.countryId,
            value: data?.couponPrice || data?.sellingPrice || String(currentSku?.originalPrice),
            items:
              detail.skuInfos?.map((item) => ({
                item_id: item.skuId,
                item_name: detail.name,
              })) || [],
          });
          dispatch(actions.setIsInitReport(true));
        }
      }
    );
  };
}
